// ---------------------------------------------------------------------------
// Matching a typed address against one already on the device.
//
// households is unique on (street_address, unit, postal_code) NULLS NOT
// DISTINCT, so this mirrors that key. Without it a canvasser re-adding an
// address they removed gets a push failure hours later, against a home the app
// has hidden from them.
// ---------------------------------------------------------------------------

/**
 * Loose enough to catch what a person would call the same address: case,
 * padding and repeated spaces do not distinguish two doors.
 *
 * Deliberately NOT a full USPS normalisation. "Rd" and "Road" produce
 * different keys here and the database would reject the second on nothing --
 * the server error is the backstop, and over-matching would be worse than
 * under-matching, because it would silently revive the wrong house.
 */
export function addressKey(
  street: string,
  unit: string | null | undefined,
  postal: string | null | undefined,
): string {
  const part = (v: string | null | undefined) =>
    (v ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
  return `${part(street)}|${part(unit)}|${part(postal)}`;
}
